import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latest = [...comics]
    .sort((a, b) => b.updateDate.localeCompare(a.updateDate))
    .slice(0, 6);

  return (
    <section className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
      <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">最新更新合集</h2>
          <p className="mt-1 text-sm text-foreground-500">刚刚更新的双女主韩漫，追更不掉队</p>
        </div>
        <Link
          to="/category/romance"
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          更多更新
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
        {latest.map((comic, index) => (
          <Link
            key={comic.id}
            to={`/detail/${comic.id}`}
            className={`group flex items-center gap-4 px-4 py-4 transition-colors hover:bg-background-100 md:px-6 ${
              index !== latest.length - 1 ? 'border-b border-background-200' : ''
            }`}
          >
            <span className="hidden w-8 shrink-0 text-center font-heading text-xl text-primary-500 md:block">
              {String(index + 1).padStart(2, '0')}
            </span>
            <span className="h-16 w-12 shrink-0 overflow-hidden rounded-md bg-background-100">
              <img
                src={comic.cover}
                alt={`${comic.title}封面`}
                title={`${comic.title} 双女主韩漫免费阅读`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="line-clamp-1 text-sm font-bold text-foreground-950 md:text-base">
                {comic.title}
              </h3>
              <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{comic.description}</p>
            </div>
            <div className="hidden shrink-0 flex-col items-end gap-1 sm:flex">
              <span className="flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">
                <i className="ri-refresh-line"></i>
                {comic.latestChapter}
              </span>
              <span className="text-xs text-foreground-400">{comic.updateDate}</span>
            </div>
            <i className="ri-arrow-right-s-line shrink-0 text-xl text-foreground-300 transition-colors group-hover:text-primary-500"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}